import template from 'template/sign_up/form/login_form';
import LoginModel from "../model/login_model";
import BaseFormComponent from "../../../common/component/base_form";
import LoginRepository from "../repository/login_repository";
import Config from "../../../main/app/service/config";

export default class LoginFormComponent extends BaseFormComponent {

    initRepository() {
        this.repository = new LoginRepository();
    }

    componentDidMount() {
        if (Config.get('is_skip_login_form')) {
            this.setState({
                second_factor_mode: true,
                provider: Config.get('second_factor_provider', 'ga'),
                cluster: this.props.cluster
            });
        }

        super.componentDidMount();
    }

    makeNewModel() {
        return new LoginModel(this.props.cluster);
    }

    onSave(model) {
        if (model.redirect_url) {
            location.href = model.redirect_url;
            if (model.force_reload) {
                location.reload();
            }
        } else {
            this.setState({
                second_factor_mode: true,
                provider: model.second_factor_provider,
                cluster: model.cluster
            });
        }
    }

    render() {
        return template.bind(this)();
    }

}